import React from 'react';
import NumberFormat from 'react-number-format';

export const CurrencyFormat = (props) => {
    const { inputRef, onChange, onBlur, ...other } = props;

    return (
        <NumberFormat
            { ...other }
            getInputRef={ inputRef }
            onValueChange={ (values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                        originalValue: values.floatValue,
                    },
                });
            } }
            onBlur={ onBlur }
            inputMode="decimal"
            thousandSeparator = '.'
            decimalSeparator = ','
            isNumericString = { true }
            allowNegative = { false }
            allowLeadingZeros = { false }
            suffix = ' kr.'
        />
    );
};

export const PercentFormat = (props) => {
    const { inputRef, onChange, onBlur, ...other } = props;

    return (
        <NumberFormat
            { ...other }
            getInputRef={ inputRef }
            onValueChange={ (values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                        originalValue: values.floatValue,
                    },
                });
            } }
            onBlur={ onBlur }
            inputMode="decimal"
            thousandSeparator = '.'
            decimalSeparator = ','
            isNumericString = { true }
            allowNegative = { false }
            allowLeadingZeros = { false }
            suffix = ' %'
        />
    );
};

const ageMaxValue = 120;
const ageValueLimit = (inputObj) => {
    const { value } = inputObj;
    if (value < ageMaxValue) return inputObj;
};

export const AgeFormat = (props) => {
    const { inputRef, onChange, onBlur, ...other } = props;

    return (
        <NumberFormat
            { ...other }
            getInputRef={ inputRef }
            onValueChange={ (values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                        originalValue: values.floatValue,
                    },
                });
            } }
            inputMode="numeric"
            isNumericString = { true }
            allowNegative = { false }
            allowLeadingZeros = { false }
            suffix = ' år'
            decimalScale = { 0 }
            isAllowed={ ageValueLimit }
        />
    );
};
export const NumericFormat = (props) => {
    const { inputRef, onChange, onBlur, ...other } = props;

    return (
        <NumberFormat
            { ...other }
            getInputRef={ inputRef }
            onValueChange={ (values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                        originalValue: values.floatValue,
                    },
                });
            } }
            inputMode="numeric"
            isNumericString = { true }
            allowNegative = { false }
            allowLeadingZeros = { false }
            suffix = ''
            decimalScale = { 0 }
        />
    );
};

const postalCodeLimit = (inputObj) => {
    const { value } = inputObj;
    if (value <= 9999 ) return inputObj;
};

export const PostalCodeFormat = (props) => {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            { ...other }
            getInputRef={ inputRef }
            onValueChange={ (values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            } }
            inputMode="decimal"
            isNumericString = { true }
            allowNegative = { false }
            allowLeadingZeros = { false }
            isAllowed={ postalCodeLimit }
        />
    );
};
